import Vue from "vue";
import Vuex from "vuex";
// import { firebaseApp, userDB, shopDB } from "@/firebaseInit";
import { getFirebase } from "@/firebaseInit";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {},
  state: {
    name: "",
    aid: "",
    sid: "",
    uid: "",
    menus: {},
    shopInfo: {},
    token: {},
    reservations: {},
    conf: {},
    slots: [],
    teamId: null
  },
  mutations: {
    SET_TEAMID(state, payload) {
      state.teamId = payload.teamId;
    },
    SET_TOKEN(state, payload) {
      state.token = payload.token;
    },
    SET_USERINFO(state, payload) {
      state.name = payload.name;
      state.sid = payload.sid;
      state.aid = payload.aid;
    },
    SET_UID(state, payload) {
      state.uid = payload.uid;
    },
    SET_SHOPINFO(state, payload) {
      state.shopInfo = payload;
    },
    SET_MENUS(state, payload) {
      Vue.set(state, "menus", payload);
    },
    SET_RESERVATIONS(state, payload) {
      state.reservations = payload;
    },
    SET_CONF(state, payload) {
      state.conf = payload.conf;
    },
    SET_SLOTS(state, payload) {
      state.slots = payload.slots;
    }
  },
  actions: {
    fetchReservations({ commit, state }) {
      return new Promise((resolve, reject) => {
        const shopDB = getFirebase(state.teamId).shopDB;
        shopDB
          .ref("reservations")
          .child(state.sid)
          .once("value", snapshot => {
            commit("SET_RESERVATIONS", snapshot.val());
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchMenus({ commit, state }) {
      return new Promise((resolve, reject) => {
        const userDB = getFirebase(state.teamId).userDB;
        userDB
          .ref("menus")
          .child(state.sid)
          .once("value", snapshot => {
            let menus = {};
            for (let mid in snapshot.val()) {
              let m = snapshot.val()[mid];
              m.id = mid;
              menus[mid] = m;
            }
            commit("SET_MENUS", menus);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchShopInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        const userDB = getFirebase(state.teamId).userDB;
        userDB
          .ref("shops")
          .child(state.aid)
          .child(state.sid)
          .once("value", snapshot => {
            commit("SET_SHOPINFO", snapshot.val());
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchShopUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        const firebaseData = getFirebase(state.teamId);
        const firebaseApp = firebaseData.app;
        const shopDB = firebaseData.shopDB;
        shopDB
          .ref("user")
          .child(firebaseApp.auth().currentUser.uid)
          .once("value", snapshot => {
            commit("SET_USERINFO", snapshot.val());
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchSlot({ commit, state }) {
      return new Promise((resolve, reject) => {
        const shopDB = getFirebase(state.teamId).shopDB;
        shopDB
          .ref("slots")
          .child(state.sid)
          .once("value", snapshot => {
            commit("SET_SLOTS", snapshot.val());
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // eslint-disable-next-line no-unused-vars
    fetchConfig({ commit }) {
      // TODO:
      // return new Promise((resolve, reject) => {
      //   shopDB
      //     .ref("default-config")
      //     .child(store.state.sid)
      //     .child("options")
      //     .once("value", snapshot => {
      //       commit("SET_CONF", snapshot.val());
      //     })
      //     .catch(err => {
      //       console.log("Fail to fetch shop id:", err.message);
      //       reject(err);
      //     });
      // });
    },
    updateMaxNum({ state }, { mid, num }) {
      return new Promise((resolve, reject) => {
        const endPoint = `menus/${state.sid}/${mid}/maxNum`;
        const userDB = getFirebase(state.teamId).userDB;
        try {
          userDB.ref(endPoint).set(num);
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
    updateSoldout({ state }, { mid, soldout }) {
      return new Promise((resolve, reject) => {
        const endPoint = `menus/${state.sid}/${mid}/soldout`;
        try {
          const userDB = getFirebase(state.teamId).userDB;
          userDB.ref(endPoint).set(soldout);
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
    updateIsDisplay({ state }, { mid, isDisplay }) {
      return new Promise((resolve, reject) => {
        const endPoint = `menus/${state.sid}/${mid}/isDisplay`;
        try {
          const userDB = getFirebase(state.teamId).userDB;
          userDB.ref(endPoint).set(isDisplay);
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
    updateMenuName({ state }, { mid, name }) {
      return new Promise((resolve, reject) => {
        const endPoint = `menus/${state.sid}/${mid}/name`;
        try {
          const userDB = getFirebase(state.teamId).userDB;
          userDB.ref(endPoint).set(name);
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
    updateMenuPrice({ state }, { mid, price }) {
      return new Promise((resolve, reject) => {
        const endPoint = `menus/${state.sid}/${mid}/price`;
        try {
          const userDB = getFirebase(state.teamId).userDB;
          userDB.ref(endPoint).set(parseInt(price));
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    },
    updateMenuEx({ state }, { mid, ex }) {
      return new Promise((resolve, reject) => {
        const endPoint = `menus/${state.sid}/${mid}/ex`;
        try {
          const userDB = getFirebase(state.teamId).userDB;
          userDB.ref(endPoint).set(ex);
          resolve();
        } catch (err) {
          reject(err);
        }
      });
    }
  },
  getters: {
    reservationDays: state => {
      return uniq(
        Object.values(state.reservations)
          .map(reserv => reserv.time - (reserv.time % 86400))
          .reverse()
      );
    },
    getMenus: state => {
      let menus = [];
      for (let mid in state.menus) {
        let menu = state.menus[mid];
        menu["id"] = mid;
        // soldout
        if (menu.soldout == 1) {
          menu["soldout"] = { value: true, text: "売切" };
        } else {
          // include undefined
          menu["soldout"] = { value: false, text: "売切" };
        }
        // isDisplay
        if (menu.isDisplay == 1) {
          // menu['isDisplay'] = true
          menu["isDisplay"] = { value: true, text: "表示" };
        } else {
          // menu['isDisplay'] = false
          menu["isDisplay"] = { value: false, text: "非表示" };
        }
        // current num
        if (menu.currentNum == undefined) {
          menu["currentNum"] = "-";
        } else {
          menu["currentNum"] = `${menu.currentNum}`;
        }

        menus.push(menu);
      }

      function compare(a, b) {
        return a.priority - b.priority;
      }

      menus.sort(compare);

      return menus;
    },
    getSlots: state => {
      let slots = [];
      for (let slot of state.slots) {
        let start_minute = slot.start % 60;
        let start_hour = (slot.start - start_minute) / 60;
        let start_string =
          ("00" + start_hour.toString()).slice(-2) +
          ":" +
          ("00" + start_minute.toString()).slice(-2);
        let end_minute = slot.end % 60;
        let end_hour = (slot.end - end_minute) / 60;
        let end_string =
          ("00" + end_hour.toString()).slice(-2) +
          ":" +
          ("00" + end_minute.toString()).slice(-2);

        slots.push({ start: start_string, end: end_string, num: slot.num });
      }

      return slots;
    }
  }
});

function uniq(array) {
  const knownElements = {};
  const uniquedArray = [];
  for (const elem of array) {
    if (elem in knownElements) continue;
    uniquedArray.push(elem);
    knownElements[elem] = true;
  }
  return uniquedArray;
}

export default store;
